export default __webpack_public_path__ + "static/media/proptiger.bd3e69b2.png";